import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    label: "Ratings",
    isTitle: true
  },
  ratings: {
    label: "Ratings",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "ratings",
        variant: "filled",
        multiline: true
      }
    ]
  },
  spShortDowngrade: {
    label: "S&P Short",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "spShortDowngrade",
        name: "spShortDowngradeId",
        variant: "filled",
        parentId: "spShortDowngrades",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  spLongDowngrade: {
    label: "S&P Long",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "spLongDowngrade",
        name: "spLongDowngradeId",
        variant: "filled",
        parentId: "spLongDowngrades",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  moodysShortDowngrade: {
    label: "Moody’s Short",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "moodysShortDowngrade",
        name: "moodysShortDowngradeId",
        variant: "filled",
        parentId: "moodysShortDowngrades",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  moodysLongDowngrade: {
    label: "Moody’s Long",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "moodysLongDowngrade",
        name: "moodysLongDowngradeId",
        variant: "filled",
        parentId: "moodysLongDowngrades",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  fitchShortDowngrade: {
    label: "Fitch Short",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "fitchShortDowngrade",
        name: "fitchShortDowngradeId",
        variant: "filled",
        parentId: "fitchShortDowngrades",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  fitchLongDowngrade: {
    label: "Fitch Long",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "fitchLongDowngrade",
        name: "fitchLongDowngradeId",
        variant: "filled",
        parentId: "fitchLongDowngrades",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  downgradeNotification: {
    label: "Downgrade Notification",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "downgradeNotification",
        label: "Notify",
        altlabel: "Do Not Notify"
      }
    ]
  }
};
